export const JOB_STATUS = {
  PENDING: 'PENDING',
  RUNNING: 'RUNNING',
  FAILED: 'FAILED',
  DONE: 'DONE'
};
